import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import merge from 'lodash.merge';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ClientProvider } from './ClientProvider';
const defaultQueryConfigs = {
    defaultOptions: {
        queries: {
            // refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000,
            cacheTime: Infinity,
        },
    },
};
export const Provider = ({ children, queryConfig, config, onTokenUpdate, }) => {
    const queryClient = new QueryClient(merge(defaultQueryConfigs, queryConfig));
    return (_jsx(ClientProvider, { config: config, onTokenUpdate: onTokenUpdate, children: _jsxs(QueryClientProvider, { client: queryClient, children: [children, _jsx(ReactQueryDevtools, {}, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=Provider.js.map